var map = {
	"./en.json": [
		45343,
		343
	],
	"./lib/en.json": [
		12303,
		303
	],
	"./lib/ru.json": [
		42988,
		988
	],
	"./ru.json": [
		44031,
		31
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83514;
module.exports = webpackAsyncContext;